module.exports = __webpack_public_path__ + "media/images/NewMBD-d91129fae9a2c1d0f34c2d25074ad9d5.jpg";